/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-case-declarations */
import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';

import '../index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import Select from '../../Select/index';
import TemplateBotFunctionalitiesInput from './TemplateBotFunctionalitiesInput';
import { readableBytes } from '../../../pages/NewBot/Components/utils';
import {
  createTemplateBot,
  updateTemplateBot,
  getTemplateBotById,
  updateTemplateBotDetails,
  getAllTemplatesBot,
} from '../../../store/actions/template-bot';
import { INITIAL_FORM_VALUE, fieldValidations } from '../data';

const TemplateBotForm = (props) => {
  const { templateBotData, templateBotId, user } = props;
  const [categories, setCategories] = useState([]);
  const [templateForm, setTemplateBotForm] = useState({
    ...INITIAL_FORM_VALUE,
    categories,
  });
  const [formErrors, setFormErrors] = useState([]);
  const [categoryInputValue, setCategoryInputValue] = useState('');
  const [functionalities, setFunctionalities] = useState([]);
  const [isFunctionalitiesTouched, setIsFunctionalitiesTouched] = useState(
    false
  );

  useEffect(() => {
    setTemplateBotForm(INITIAL_FORM_VALUE);
    setCategories([]);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(templateBotData)) {
      setTemplateBotDataForm();
    } else if (templateBotId) {
      const { getTemplateBotById } = props;
      getTemplateBotById(templateBotId);
    }
  }, [templateBotData]);

  useEffect(() => {
    if (!_.isEqual(_.sortBy(templateForm.categories), _.sortBy(categories))) {
      onChangeFormField(categories, 'categories');
    }
  }, [categories]);

  useEffect(() => {
    if (
      isFunctionalitiesTouched &&
      !_.isEqual(
        _.sortBy(templateForm.functionalities),
        _.sortBy(functionalities)
      )
    ) {
      onChangeFormField(functionalities, 'functionalities');
    }
  }, [functionalities]);

  const setTemplateBotDataForm = () => {
    const newCategories = [
      ...templateBotData.categories.map((element) => ({
        label: element,
        value: element,
      })),
    ];
    const newFunctionalities = [...templateBotData.functionalities];
    setCategories(newCategories);
    setFunctionalities(newFunctionalities);
    const {
      _id,
      botId,
      fromBotId,
      banner,
      when,
      __v,
      ...data
    } = templateBotData;
    // const file = new File([banner], `${data.title}-avatar.png`, {
    //   type: 'image/*',
    //   lastModified: Date.now(),
    // });

    const newTemplateForm = {
      ...data,
      categories: newCategories,
      functionalities: newFunctionalities,
      avatarBot: banner,
    };
    setTemplateBotForm(newTemplateForm);
  };

  const handleChange = useCallback((_categories) => {
    if (_categories) {
      setCategories(_categories);
    } else {
      setCategories([]);
    }
  }, []);

  const handleInputChange = useCallback((_value) => {
    setCategoryInputValue(_value);
  }, []);

  const handleKeyDown = useCallback(
    (event) => {
      if (!categoryInputValue) return;
      switch (event.key) {
        case 'Enter':
        case 'Tab':
          setCategoryInputValue('');

          const categoryExists = categories.find(
            (category) => category.value === categoryInputValue
          );
          if (categoryExists) return;

          if (categories.length !== 5) {
            setCategories([
              ...categories,
              { label: categoryInputValue, value: categoryInputValue },
            ]);
          }

          event.preventDefault();
          break;
        default:
          break;
      }
    },
    [categoryInputValue, categories]
  );

  const onChangeFormField = (value, key) => {
    if (fieldValidations[key]) {
      const isValid = fieldValidations[key](value);

      const hasError = formErrors.indexOf(key);
      const newFormErrors = [...formErrors];
      if (hasError > -1) {
        if (isValid) {
          newFormErrors.splice(hasError, 1);
        }
      } else if (!isValid) {
        newFormErrors.push(key);
      }
      setFormErrors(newFormErrors);
    }

    const newTemplateBotForm = { ...templateForm, [key]: value };
    setTemplateBotForm(newTemplateBotForm);
  };

  const onChangeBotAvatar = ({ target }) => {
    const { files } = target;
    const isValid = fieldValidations.avatarBot(files[0]);
    if (isValid) {
      const blob = URL.createObjectURL(files[0]);
      const file = new File([blob], `test.png`, {
        type: 'image/*',
        lastModified: Date.now(),
      });
      const { value, base } = readableBytes(file.size);

      if (base !== 'B' && base !== 'KB') {
        if (value > 5) {
          toastr.error(
            'Ops',
            'Por favor, a imagem deve ter tamanho máximo de 5 MB.'
          );
          return;
        }
      }

      const img = document.createElement('img');
      img.src = blob;
      img.style = { display: 'none' };
      img.onload = function () {
        const { width, height } = img;
        if (width !== 720 || height !== 250) {
          toastr.error('Ops', 'Por favor, a imagem deve ter 720x250.');
        } else {
          const newTemplateBotForm = {
            ...templateForm,
            avatarBot: this.file,
          };
          setTemplateBotForm(newTemplateBotForm);
        }
      }.bind({ file: files[0] });
    }
    target.value = null;
  };

  const saveTemplateBotData = () => {
    const userId = user._id;
    const { _id, botId } = templateBotData;
    const {
      bot,
      items,
      connectors,
      createTemplateBot,
      updateTemplateBot,
      updateTemplateBotDetails,
      setShow,
    } = props;
    const { categories, functionalities, ...data } = templateForm;

    const newTemplateForm = {
      ...data,
      userId,
      categories: JSON.stringify(categories.map((cat) => cat.value)),
      functionalities: JSON.stringify(
        functionalities.filter((func) => func.length !== 0)
      ),
      ...(bot && { bot: JSON.stringify(bot) }),
      ...(items && { items: JSON.stringify(items) }),
      ...(connectors && { connectors: JSON.stringify(connectors) }),
      ...(_id && { _id }),
      ...(botId && { botId }),
    };

    if (!items || !connectors) {
      const { getAllTemplatesBot } = props;
      updateTemplateBotDetails(newTemplateForm);
      getAllTemplatesBot();
    } else if (_id) {
      updateTemplateBot(newTemplateForm);
    } else {
      createTemplateBot(newTemplateForm);
    }

    setShow(false);
  };

  const onClickSaveTemplateBot = (event) => {
    event.preventDefault();
    const newFormErrors = [...formErrors];

    Object.keys(templateForm).forEach((key) => {
      if (fieldValidations[key]) {
        const isValid = fieldValidations[key](templateForm[key]);
        const index = formErrors.indexOf(key);
        if (!isValid) {
          if (index === -1) {
            newFormErrors.push(key);
          }
        } else if (index > -1) {
          newFormErrors.splice(index, 1);
        }
      }
    });

    if (newFormErrors.length > 0) {
      // const text = `Campos com erro: ${newFormErrors.map(
      //   (value) => `${value} `
      // )}`;
      toastr.error(
        'Ops',
        `As informações sobre o template não estão corretas.`
      );
    } else {
      saveTemplateBotData();
    }

    setFormErrors(newFormErrors);
  };

  const getCharacterLeftTextarea = (key) => {
    const max = key === 'longDescription' ? 650 : 150;
    return max - templateForm[key].length;
  };

  const addInputErrorClass = (key) => {
    return formErrors.indexOf(key) > -1 ? `template-bot-modal-input-error` : ``;
  };

  return (
    <Fragment>
      <Modal.Body className="modal-body template-bot-modal">
        <form id="templateForm">
          <div className="template-bot-modal-content-row">
            <div>
              <div className="template-bot-upload-banner-container">
                <div className="template-bot-modal-content-column">
                  <label>Imagem ilustrativa*:</label>
                  <div className="template-bot-upload-input">
                    <label htmlFor="avatarBot">Upload de arquivo</label>
                    <input
                      id="avatarBot"
                      type="file"
                      accept=".png,.jpg,.jpeg"
                      onChange={onChangeBotAvatar}
                    />
                  </div>
                </div>
                <span>
                  imagem deve estar em formato .JPG, .JPEG ou .PNG ter no mínimo
                  720x250 pixels e no máximo 5mb
                </span>
              </div>

              <div
                className={`template-bot-modal-content-column ${addInputErrorClass(
                  'title'
                )}`}
              >
                <label>Nome*</label>
                <input
                  id="title"
                  type="text"
                  name="title"
                  maxLength={26}
                  value={templateForm.title || ''}
                  placeholder="Seu bot"
                  onChange={({ target }) =>
                    onChangeFormField(target.value, 'title')
                  }
                />
              </div>

              <div
                className={`template-bot-modal-content-column ${addInputErrorClass(
                  'categories'
                )}`}
              >
                <label>Categoria*</label>
                <div className="template-bot-modal-select">
                  <Select
                    id="categories"
                    placeholder="Ex.: RH"
                    name="categories"
                    inputValue={categoryInputValue}
                    value={categories || []}
                    onChange={handleChange}
                    onInputChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    menuIsOpen={false}
                    inputMaxLength={30}
                    isMulti
                  />
                </div>
              </div>

              <div
                className={`template-bot-modal-content-column ${addInputErrorClass(
                  'shortDescription'
                )}`}
              >
                <label>Descrição curta*</label>
                <textarea
                  id="shortDescription"
                  name="shortDescription"
                  maxLength={150}
                  placeholder="Descrição curta do bot"
                  onChange={({ target }) =>
                    onChangeFormField(target.value, 'shortDescription')
                  }
                  value={templateForm.shortDescription || ''}
                  style={{ minHeight: 54 }}
                />
                <span>{`(${getCharacterLeftTextarea(
                  'shortDescription'
                )})`}</span>
              </div>

              <div
                className={`template-bot-modal-content-column ${addInputErrorClass(
                  'longDescription'
                )}`}
              >
                <label style={{ width: 'auto' }}>Descrição detalhada*</label>
                <textarea
                  id="longDescription"
                  name="longDescription"
                  maxLength={650}
                  value={templateForm.longDescription || ''}
                  onChange={({ target }) =>
                    onChangeFormField(target.value, 'longDescription')
                  }
                  style={{ minHeight: 178 }}
                />
                <span>{`(${getCharacterLeftTextarea(
                  'longDescription'
                )})`}</span>
              </div>
            </div>
            <div className="template-bot-modal-content-column">
              <TemplateBotFunctionalitiesInput
                templateBotData={templateBotData}
                functionalities={functionalities}
                isFunctionalitiesTouched={isFunctionalitiesTouched}
                setIsFunctionalitiesTouched={setIsFunctionalitiesTouched}
                setFunctionalities={setFunctionalities}
                addInputErrorClass={addInputErrorClass}
              />
            </div>
          </div>

          <div className="float-left template-bot-modal-toggle-container">
            <div className="custom-control custom-switch mt-2 bo-toggle template-bot-modal-toggle">
              <input
                type="checkbox"
                name="template-bot-modal-toggle-component"
                id="template-bot-modal-toggle-component"
                className="custom-control-input"
                checked={templateForm.published || false}
                onChange={() =>
                  onChangeFormField(!templateForm.published, 'published')
                }
              />
              <label
                className="custom-control-label bot-control-label"
                htmlFor="template-bot-modal-toggle-component"
              />
            </div>
            <div className="enable-channel-text">
              <span>Template visível</span>
            </div>
          </div>
          <div className="template-bot-modal-submit-container">
            <button
              type="button"
              className="btn btn-primary"
              form="templateForm"
              onClick={onClickSaveTemplateBot}
            >
              salvar
            </button>
          </div>
        </form>
      </Modal.Body>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    templateBotData: state.templateBot.templateBotData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getTemplateBotById,
      createTemplateBot,
      updateTemplateBot,
      updateTemplateBotDetails,
      getAllTemplatesBot,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TemplateBotForm)
);
